/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Shownotificationbell2Inputs */

const en_entity_shownotificationbell2 = /** @type {(inputs: Entity_Shownotificationbell2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Notification Bell`)
};

const de_entity_shownotificationbell2 = /** @type {(inputs: Entity_Shownotificationbell2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungsglocke anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Notification Bell" |
*
* @param {Entity_Shownotificationbell2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_shownotificationbell2 = /** @type {((inputs?: Entity_Shownotificationbell2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Shownotificationbell2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_shownotificationbell2(inputs)
	return de_entity_shownotificationbell2(inputs)
});
export { entity_shownotificationbell2 as "entity_showNotificationBell" }